<script lang="ts">
	import { formatDate } from "$internal/utils/date";

    export let date: Date | number | string
    export let locale = "en-US"
    export let options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' }
</script>

<time datetime={new Date(date).toISOString()}>
    {formatDate(date, locale, options)}
</time>